<div class="w-100">
  <div class="header" *ngIf="dialogData?.isOpenedFromDashboard">
<div class="d-flex w-100 py-3 px-4">
            <div class="me-2 id flex-fill">
              <h4 class="modal-title mb-0 item-id">
                Opportunities - {{ dialogData?.filteredStatus }}
              </h4>
            </div>

            <div class="btns-header">
              <button class="close" (click)="dialogRef.close()" aria-label="Close">
                <i class="fas fa-times" title="Close Popup"></i>
              </button>
              <!-- <button class="close expand-modal" (click)="expandCollapse()">
                <i class="fas ms-2 me-2" style="font-weight: bold;" [ngClass]="{'fa-expand-alt': !isExpanded, 'fa-compress-alt': isExpanded}"
                [title]="isExpanded ? 'Exit Full Screen' : 'Enter Full Screen'"></i>
              </button> -->
            </div>
          </div>
  </div>
    <app-loader *ngIf="showLoader"></app-loader>
    <ejs-grid
        *ngIf="showGrid"
        [id]="gridName"
        #opportunityGrid
        [dataSource]="dataSource"
        [allowPaging]="true"
        [pageSettings]="{ pageSizes: [20, 50, 100, 500], pageSize: 20 }"
        [gridLines]="false"
        [query]="query"
        [allowFiltering]="true"
        [enablePersistence]="true"
        [showColumnChooser]="true"
        [height]="gridHeight"
        [allowSorting]="true"
        [sortSettings]="sortOptions"
        [enableHover]="false"
        [enablePersistence]="!dialogData?.isOpenedFromDashboard"
        [allowResizing]="true"
        [allowReordering]="true"
        [allowExcelExport]="true"
        [allowSelection]="true"
        [searchSettings]="searchSettings"
        [editSettings]="{ allowEditing: false }"
        [filterSettings]="{ type: 'Menu' }"
        (toolbarClick)="onToolbarClick($event)"
        (rowDataBound)="onRowDataBound($event)"
        (dataBound)="dataBound($event)"
        (commandClick)="commandClick($event, opportunityGrid)"
        (created)="created()"
        (actionComplete)="onGridActionComplete($event, opportunityGrid)"
        >
        <e-columns>
            <e-column
                *ngFor="let column of columns;"
                [field]="column.field"
                [headerText]="column.headerText"
                [clipMode]="column.field === 'Actions' ? '' : 'EllipsisWithTooltip'"
                [type]="column.type"
                [width]="column.width"
                [filter]="column.filter ? column.filter : { type: 'Menu' }"
                [format]="column.format ? column.format : null"
                [textAlign]="column.textAlign"
                [showInColumnChooser]="column.showInColumnChooser"
                [visible]="column.visible"
                [commands]="column?.commands ? column.commands : null"
                [edit]="column.edit"
                [allowReordering]="column.allowReordering ?? true"
                [freeze]="column.freeze ? column.freeze: null"
                [allowEditing]="column.allowEditing"
                [allowSorting]="column.allowSorting ?? true"
                [allowFiltering]="column.allowFiltering !== undefined ? column.allowFiltering : true">
                <ng-template *ngIf="column.field === 'statusText'" #template let-data>
                  <span class="grid-status-column" [ngStyle]="{'background-color': data.statusColorCode}">{{data.statusText}}</span>
                </ng-template>
                <ng-template *ngIf="column.field === 'opportunityId'" #template let-data>
                  <a href="javascript:" (click)="openOpportunityPopup(data.opportunityId, 'details')">{{data.opportunityId}}</a>
                </ng-template>
                @if(dialogData?.isOpenedFromDashboard) {
          <ng-template *ngIf="column.field === 'businessPartner'" #template let-data>
                 {{data?.soldToBP +" - "+data.businessPartner}}
                </ng-template>
        } @else {
          <ng-template *ngIf="column.field === 'businessPartner'" #template let-data>
                  <a href="javascript:" (click)="onBPIdClick(data.soldToBP)">{{data.businessPartner}}</a>
                </ng-template>
        }

                <ng-template *ngIf="column.field === 'salesLeadId'" #template let-data>
                  <a href="javascript:" (click)="openLeadsPopup(data.salesLeadId)">{{data.salesLeadId}}</a>
                </ng-template>
            </e-column>
        </e-columns>
    </ejs-grid>
  </div>

  <ng-template #columnChooser>
    <app-column-chooser
        [grid]="grid"
    ></app-column-chooser>
  </ng-template>

  <ng-template #addLeads>
    <i *ngIf="rolePermissions['opportunityGrid_add']?.visible" class="fas fa-add"></i>
  </ng-template>

  <app-prospects-popup
  *ngIf="showProspectsPopup"
    [prospectData]="prospectData"
    [tab]="tab"
    (onClose)="showProspectsPopup = false"
    >
  </app-prospects-popup>
